/**
 * Suddivisione degli stati di una scheda di lavoro nei regimi di prodotto.
 *
 * Regola confermata il 26/08/2026 — NON deducibile dal database.
 * Il database conosce solo la lista degli stati; la suddivisione in regimi
 * è una regola di business decisa a livello di prodotto.
 *
 * Se compare uno stato non elencato, viene trattato come "manuale" senza
 * interrompere l'applicazione.
 */

export type Regime = 'manuale' | 'automatico' | 'chiusura' | 'fuori linea'

const REGIMI_MAP: Record<string, Regime> = {
  // Passaggi decisi dall'operatore (accettazione, analisi, approvazione)
  bozza: 'manuale',
  accettazione: 'manuale',
  'in analisi': 'manuale',
  'in approvazione': 'manuale',
  approvata: 'manuale',

  // Passaggi pilotati dal completamento degli interventi
  'in lavorazione': 'automatico',
  completata: 'automatico',

  // Chiusura del ciclo con riconsegna
  riconsegnata: 'chiusura',

  // Stati fuori dal flusso principale
  sospesa: 'fuori linea',
  annullata: 'fuori linea',
}

/** Restituisce il regime dello stato. Fallback: 'manuale'. */
export const getRegime = (stato: string): Regime =>
  REGIMI_MAP[stato] ?? 'manuale'

export const LABEL_REGIME: Record<Regime, string> = {
  manuale: 'manuale',
  automatico: 'automatico',
  chiusura: 'chiusura',
  'fuori linea': 'fuori linea',
}
